<template>
  <div class="fts-query">
    <div class="fts-query-wrapper">
      <slot name="header"></slot>
      <!--variable-->
      <template v-if="filter.type === 'formula'">
        <!-- information -->
        <fts-dropdown-select
          append-to-body
          prevent-overflow-tether-off
          append-content-class="query-content query-dropdown-menu"
          class="query-dropdown"
          @selected="setFieldName"
          v-if="true"
        >
          <div slot="toggle" class="query-dropdown-toggle">
            <fts-label-group
              :item="getFilterInfo"
              information
              :information-modules="modules"
              emoji
              :emoji-size="14"
              class="query-dropdown-toggle-label"
              :data-filter-label="getFilterInfo.displayName"
              v-if="getFilterInfo"
            />
            <div class="query-dropdown-toggle-label" v-else>
              {{ getInformationDisplayName(filter) }}
            </div>
          </div>
          <template #menu="{ select }">
            <div class="query-filter">
              <div class="fts-form-control-filter">
                <input
                  type="text"
                  class="fts-form-control"
                  placeholder="Search something for..."
                  autocomplete="query-filter-input"
                  v-model.trim="selectionFilter"
                />
                <div class="search-icon">
                  <font-awesome-icon :icon="['fas', 'search']" fixed-width />
                </div>
              </div>
            </div>
            <fts-label-group
              v-for="item in getSelection"
              :key="item.id"
              :item="{
                ...item,
                'displayName': item.label || item.displayName,
                'icon': informationIcon(item),
                'system': getDefaultSelection(item)
              }"
              information
              :information-modules="modules"
              emoji
              :emoji-size="14"
              class="dropdown-option"
              @click.native="select(item)"
            >
              <template slot-scope="{ label }">
                {{label}}
                <fts-release-badge dev class="fts-align-top" v-if="item.isDev" />
                <fts-release-badge alpha class="fts-align-top" v-else-if="item.isAlpha" />
                <fts-release-badge class="fts-align-top" v-else-if="item.isBeta" />
              </template>
            </fts-label-group>
          </template>
        </fts-dropdown-select>
        <!-- operator -->
        <fts-dropdown-select
          append-to-body
          prevent-overflow-alt-axis
          prevent-overflow-tether-off
          class="query-dropdown"
          @selected="changeOperator"
          v-if="filter.type !== 'custom'"
        >
          <div slot="toggle" class="query-dropdown-toggle">
            <div
              class="query-dropdown-toggle-label"
              :class="{ 'label-border': searchTextType === 'YesNo' }"
              data-filter-operator
            >
              <font-awesome-icon
                class="yes-icon"
                :icon="['fas', 'check']"
                fixed-width
                v-if="
                  filter.type === 'boolean' &&
                  getSearchTypeDisplay(filter) === 'yes'
                "
              />
              <font-awesome-icon
                class="no-icon"
                :icon="['fas', 'times']"
                fixed-width
                v-else-if="
                  filter.type === 'boolean' &&
                  getSearchTypeDisplay(filter) === 'no'
                "
              />
              {{ getSearchTypeDisplay(filter) }}
            </div>
          </div>
          <template #menu="{ select, defaultOptionClass }">
            <div
              :class="defaultOptionClass"
              v-for="searchType in getSearchTypes('formula')"
              :key="searchType.id"
              @click="select(searchType)"
            >
              <font-awesome-icon
                class="yes-icon"
                :icon="['fas', 'check']"
                fixed-width
                v-if="
                  filter.type === 'boolean' && searchType.fieldName === 'yes'
                "
              />
              <font-awesome-icon
                class="no-icon"
                :icon="['fas', 'times']"
                fixed-width
                v-else-if="
                  filter.type === 'boolean' && searchType.fieldName === 'no'
                "
              />
              {{ searchType.displayName }}
            </div>
          </template>
        </fts-dropdown-select>

        <fts-formula
          :variables="variables"
          v-model="filter.formula"
          class="query-formula-control"
        />
      </template>
      <!-- custom -->
      <template v-else-if="filter.type === 'custom' && mode != 'view'">
        Name:
        <input
          type="text"
          autocomplete="query-filter-script-input"
          v-model="filter.displayName"
        />
        Script:
        <textarea v-model="filter.script" />
      </template>
      <template v-else-if="filter.type === 'custom'">
        <div class="query-dropdown-toggle-label">
          {{ filter.displayName }}
        </div>
        <div class="fts-form-element-theme query-search-form">
          <div class="compact-form-design">
            <div class="query-search-form-wrapper">
              <!-- Custom -->
              <div class="query-search-form-group custom-script">
                <input
                  type="text"
                  class="fts-form-control"
                  autocomplete="query-script-input"
                  v-model="filter.payload"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- condition and, or  -->
      <template v-else-if="filter.type === 'and' || filter.type === 'or'">
        <draggable
          class="query-designer-row nested-query"
          :class="{ 'or-container': filter.type === 'or' }"
          v-model="filter.items"
          :group="{ name: 'query' }"
          v-bind="dragOptions"
          draggable=".draggable-item"
          handle=".handle"
        >
          <template v-for="(filterItem, index) in filter.items">
            <div
              class="query-designer-row-wrapper draggable-item nested-query-wrapper"
              :key="filterItem.id"
            >
              <div
                class="query-badge"
                v-show="index != 0"
                :class="{ 'or-query-badge': filter.type === 'or' }"
                @click="toggleContainerType()"
              >
                {{ filter.type }}
              </div>
              <fts-query
                :modules="modules"
                :states="states"
                :information-source="informationSource"
                :variables="variables"
                :filter="filterItem"
                @update="updateFilter"
                @remove="removeFilter(filterItem)"
              >
                <template #header>
                  <font-awesome-icon
                    :icon="['fas', 'grip-vertical']"
                    fixed-width
                    class="query-designer-handle handle"
                  />
                </template>
              </fts-query>
            </div>
          </template>
          <div class="nested-query-wrapper">
            <!-- <div class="query-badge" :class="{ 'or-query-badge': filter.type === 'or' }" @click="toggleContainerType()">{{filter.type}}</div> -->
            <div slot="footer">
              <!-- <font-awesome-icon :icon="['fas', 'plus']" fixed-width /> -->
              <div
                class="query-badge"
                :class="{
                  'or-query-badge': filter.type === 'or',
                  'grayscale-badge':
                    filter.filterItems && filter.filterItems.length >= 2,
                }"
                @click="addFilter()"
              >
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />
                {{ filter.type }} condition
              </div>
              <!-- <div>condition</div> -->
            </div>
          </div>
        </draggable>
      </template>
      <!-- condition not -->
      <template v-else-if="filter.type === 'not'">
        <draggable
          class="query-designer-row nested-query"
          v-model="filter.items"
          :group="{ name: 'query' }"
          v-bind="dragOptions"
          draggable=".draggable-item"
          handle=".handle"
        >
          <template v-for="(filterItem, index) in filter.items">
            <div
              class="query-designer-row-wrapper draggable-item nested-query-wrapper"
              :key="filterItem.id"
            >
              <div
                class="query-badge"
                v-show="index != 0"
                :class="{ 'not-query-badge': filter.type === 'not' }"
                @click="toggleContainerType()"
              >
                {{ filter.type }}
              </div>
              <fts-query
                :modules="modules"
                :states="states"
                :information-source="informationSource"
                :variables="variables"
                :filter="filterItem"
                @update="updateFilter"
                @remove="removeFilter(filterItem)"
              >
                <template #header>
                  <font-awesome-icon
                    :icon="['fas', 'grip-vertical']"
                    fixed-width
                    class="handle"
                  />
                </template>
              </fts-query>
            </div>
          </template>
          <div class="nested-query-wrapper">
            <!-- <div class="query-badge" :class="{ 'or-query-badge': filter.type === 'or' }" @click="toggleContainerType()">{{filter.type}}</div> -->
            <div slot="footer">
              <!-- <font-awesome-icon :icon="['fas', 'plus']" fixed-width /> -->
              <div
                class="query-badge"
                :class="{
                  'not-query-badge': filter.type === 'not',
                  'grayscale-badge':
                    filter.filterItems && filter.filterItems.length >= 2,
                }"
                @click="addFilter()"
              >
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width />
                {{ filter.type }} condition
              </div>
              <!-- <div>condition</div> -->
            </div>
          </div>
        </draggable>
      </template>
      <!-- query -->
      <template v-else>
        <!-- information -->
        <fts-dropdown-select
          append-to-body
          prevent-overflow-alt-axis
          prevent-overflow-tether-off
          append-content-class="query-content query-dropdown-menu"
          class="query-dropdown"
          @selected="setFieldName"
        >
          <div slot="toggle" class="query-dropdown-toggle">
            <fts-label-group
              :item="getFilterInfo"
              information
              :information-modules="modules"
              emoji
              :emoji-size="14"
              class="query-dropdown-toggle-label"
              :data-filter-label="getFilterInfo.displayName"
              v-if="getFilterInfo"
            />
            <div class="query-dropdown-toggle-label" v-else>
              {{ getInformationDisplayName(filter) }}
            </div>
          </div>
          <template #menu="{ select }">
            <div class="query-filter">
              <div class="fts-form-control-filter">
                <input
                  type="text"
                  class="fts-form-control"
                  placeholder="Search something for..."
                  autocomplete="query-selection-filter-input"
                  v-model.trim="selectionFilter"
                />
                <div class="search-icon">
                  <font-awesome-icon :icon="['fas', 'search']" fixed-width />
                </div>
              </div>
            </div>
            <fts-label-group
              v-for="item in getSelection"
              :key="item.id"
              :item="{
                ...item,
                'displayName': item.label || item.displayName,
                'icon': informationIcon(item),
                'system': getDefaultSelection(item)
              }"
              information
              :information-modules="modules"
              emoji
              :emoji-size="14"
              class="dropdown-option"
              @click.native="select(item)"
            >
              <template slot-scope="{ label }">
                {{label}}
                <fts-release-badge dev class="fts-align-top" v-if="item.isDev" />
                <fts-release-badge alpha class="fts-align-top" v-else-if="item.isAlpha" />
                <fts-release-badge class="fts-align-top" v-else-if="item.isBeta" />
              </template>
            </fts-label-group>
          </template>
        </fts-dropdown-select>
        <!-- operator -->
        <fts-dropdown-select
          append-to-body
          prevent-overflow-alt-axis
          prevent-overflow-tether-off
          class="query-dropdown"
          @selected="changeOperator"
          v-if="filter.type !== 'custom'"
        >
          <div slot="toggle" class="query-dropdown-toggle">
            <div
              class="query-dropdown-toggle-label"
              :class="{ 'label-border': searchTextType === 'YesNo' }"
              data-filter-operator
            >
              <font-awesome-icon
                class="yes-icon"
                :icon="['fas', 'check']"
                fixed-width
                v-if="
                  filter.type === 'boolean' &&
                  getSearchTypeDisplay(filter) === 'yes'
                "
              />
              <font-awesome-icon
                class="no-icon"
                :icon="['fas', 'times']"
                fixed-width
                v-else-if="
                  filter.type === 'boolean' &&
                  getSearchTypeDisplay(filter) === 'no'
                "
              />
              {{ getSearchTypeDisplay(filter) }}
            </div>
          </div>
          <template #menu="{ select, defaultOptionClass }">
            <div
              :class="defaultOptionClass"
              v-for="searchType in getSearchTypes(
                getInformationType(filter.fieldId)
              )"
              :key="searchType.id"
              @click="select(searchType)"
            >
              <font-awesome-icon
                class="yes-icon"
                :icon="['fas', 'check']"
                fixed-width
                v-if="
                  filter.type === 'boolean' && searchType.fieldName === 'yes'
                "
              />
              <font-awesome-icon
                class="no-icon"
                :icon="['fas', 'times']"
                fixed-width
                v-else-if="
                  filter.type === 'boolean' && searchType.fieldName === 'no'
                "
              />
              {{ searchType.displayName }}
            </div>
          </template>
        </fts-dropdown-select>
        <!-- search text -->
        <div class="fts-form-element-theme query-search-form">
          <div class="compact-form-design">
            <div class="query-search-form-wrapper">
              <!-- custom -->
              <div
                class="query-search-form-group custom-script"
                v-if="filter.type === 'custom'"
              >
                <input
                  type="text"
                  class="fts-form-control"
                  autocomplete="query-custom-script-input"
                />
              </div>
              <!--all / any -->
              <template
                v-else-if="
                  filter.operator === 'all' || filter.operator === 'any'
                "
              >
                <draggable
                  class="query-designer-row nested-query"
                  v-model="filter.items"
                  :group="{ name: `query-${filter.fieldId}` }"
                  v-bind="dragOptions"
                  draggable=".draggable-item"
                  handle=".handle"
                  v-if="getTableInformationSource(filter).length"
                >
                  <div
                    v-for="filterItem in filter.items"
                    :key="filterItem.id"
                    class="query-designer-row-wrapper draggable-item nested-query-wrapper"
                  >
                    <fts-query
                      :modules="modules"
                      :states="states"
                      :information-source="getTableInformationSource(filter)"
                      :variables="variables"
                      :filter="filterItem"
                      @update="updateFilter"
                      @remove="removeFilter(filterItem)"
                    >
                      <template #header>
                        <font-awesome-icon
                          :icon="['fas', 'grip-vertical']"
                          fixed-width
                          class="query-designer-handle handle"
                        />
                      </template>
                    </fts-query>
                  </div>
                  <div class="nested-query-wrapper">
                    <div slot="footer">
                      <div
                        class="query-badge"
                        :class="{
                          'grayscale-badge':
                            filter.filterItems &&
                            filter.filterItems.length >= 2,
                        }"
                        @click="addFilter(getTableInformationSource(filter))"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'plus']"
                          fixed-width
                        />
                        condition
                      </div>
                    </div>
                  </div>
                </draggable>
                <div class="query-search-form-text" v-else>no searchable information</div>
              </template>
              <!-- text input -->
              <fts-formula-switch
                :variables="variables"
                v-model="filter.payload"
                :disabled-toggle="!formulaSwitchEnabled"
                class="query-search-form-group"
                @input="onTextInput"
                v-else-if="isTextInput"
              >
                <!-- select option:is -->
                <fts-dropdown-select
                  append-to-body
                  :options="getSelectOptions"
                  prevent-overflow-alt-axis
                  prevent-overflow-tether-off
                  :reduce="(x) => x.name"
                  v-model="filter.payload"
                  append-content-class="query-content query-select-menu"
                  placeholder="any"
                  class="query-dropdown"
                  v-if="getSelectOptions && filter.operator === 'is'"
                >
                  <div
                    slot="toggle"
                    slot-scope="{ selectedOption, selectedOptionValue }"
                    class="query-dropdown-toggle query-select-toggle"
                  >
                    <div
                      class="query-select-option"
                      :style="{
                        'background-color':
                          getSelectOptionColor(selectedOptionValue),
                      }"
                      v-if="selectedOption"
                    >
                      {{ selectedOptionValue }}
                    </div>
                    <div class="query-select-option" v-else>any</div>
                  </div>
                  <div
                    slot="option"
                    slot-scope="{ option, select, defaultClass }"
                    :class="defaultClass"
                    @click="select(option)"
                  >
                    <div
                      class="query-select-option"
                      :style="{
                        'background-color': getSelectOptionColor(option.name),
                      }"
                      v-if="option.id"
                    >
                      {{ option.name ? option.name : "(undefined)" }}
                    </div>
                    <div class="query-select-option" v-else>any</div>
                  </div>
                </fts-dropdown-select>
                <!-- textArea:is -->
                <textarea
                  class="fts-form-control fts-resize-none"
                  rows="3"
                  v-model="filter.payload"
                  @input="onTextInput"
                  v-else-if="
                    searchTextType === 'Textarea' && filter.operator === 'is'
                  "
                />
                <!-- user:is -->
                <fts-user
                  :form-data="fieldFormData"
                  :item="userFieldItem"
                  :user-list="users"
                  reduce-key="username"
                  :additional-filter-keys="['displayName']"
                  width="250px"
                  @username="(val) => setUserName(val)"
                  v-else-if="
                    (searchTextType === 'User' ||
                      searchTextType === 'Profile (Module)') &&
                    filter.operator == 'is'
                  "
                />
                <!-- default -->
                <input
                  type="text"
                  class="fts-form-control"
                  autocomplete="query-search-input"
                  v-model.trim="filter.payload"
                  @input="onTextInput"
                  ref="test"
                  v-else
                />
              </fts-formula-switch>
              <!-- number -->
              <template v-else-if="searchTextType === 'Number'">
                <!-- between -->
                <template v-if="filter.operator === 'between'">
                  <div class="query-search-form-group query-search-number">
                    <div class="query-search-number__label">min</div>
                    <fts-number-currency
                      v-model="mutableMin"
                      :numeral-decimal-scale="13"
                      class="query-search-number__input"
                    />
                  </div>

                  <div class="query-search-form-group query-search-number">
                    <div class="query-search-number__label">max</div>
                    <fts-number-currency
                      v-model="mutableMax"
                      :numeral-decimal-scale="13"
                      class="query-search-number__input"
                    />
                  </div>
                </template>
                <!-- greater than equal -->
                <fts-formula-switch
                  :variables="variables"
                  v-model="mutableMax"
                  :disabled-toggle="!formulaSwitchEnabled"
                  class="query-search-form-group"
                  v-else-if="filter.operator === 'gte'"
                >
                  <fts-number-currency
                    v-model="mutableMin"
                    :numeral-decimal-scale="13"
                    class="query-number-input"
                  />
                </fts-formula-switch>
                <!-- less than equal -->
                <fts-formula-switch
                  :variables="variables"
                  v-model="mutableMax"
                  :disabled-toggle="!formulaSwitchEnabled"
                  class="query-search-form-group"
                  v-else-if="filter.operator === 'lte'"
                >
                  <fts-number-currency
                    v-model="mutableMax"
                    :numeral-decimal-scale="13"
                    class="query-number-input"
                  />
                </fts-formula-switch>
                <!-- equal -->
                <fts-formula-switch
                  :variables="variables"
                  v-model="mutableEqual"
                  :disabled-toggle="!formulaSwitchEnabled"
                  class="query-search-form-group"
                  v-else-if="filter.operator === 'eq'"
                >
                  <fts-number-currency
                    v-model="mutableEqual"
                    :numeral-decimal-scale="13"
                    class="query-number-input"
                  />
                </fts-formula-switch>
              </template>
              <!-- date -->
              <template v-else-if="searchTextType === 'Date'">
                <!-- date range picker -->
                <fts-date-time-range
                  class="query-search-form-group form-group-date-time-range"
                  :formData="filter"
                  :item="{ fieldName: 'payload' }"
                  v-if="filter.operator === 'between'"
                />
                <!-- date picker -->
                <fts-formula-switch
                  :variables="variables"
                  v-model="filter.payload"
                  :disabled-toggle="!formulaSwitchEnabled"
                  class="query-search-form-group"
                  v-else-if="
                    filter.operator === 'gt' || filter.operator === 'lt'
                  "
                >
                  <fts-date-time
                    append-to-body
                    full-width
                    :item="{ type: 5 }"
                    v-model="mutableDateBeforeAfter"
                  />    
                </fts-formula-switch>
                <!-- date in / past -->
                <fts-formula-switch
                  :variables="variables"
                  v-model="mutableOffset"
                  :disabled-toggle="!formulaSwitchEnabled"
                  :default-value="0"
                  class="query-search-form-group"
                  v-else-if="
                    filter.operator === 'in' || filter.operator === 'past'
                  "
                >
                  <fts-integer
                    v-model="mutableOffset"
                    :min="0"
                    :max="999"
                    class="query-number-input"
                  />
                </fts-formula-switch>
                <!-- duration (duration type: day, week, month) -->
                <fts-dropdown-select
                  append-to-body
                  :options="getDateTypes"
                  option-key="displayName"
                  prevent-overflow-alt-axis
                  prevent-overflow-tether-off
                  class="query-dropdown"
                  @selected="setDateDurationOffset"
                  v-if="
                    filter.operator === 'in' ||
                    filter.operator === 'past' ||
                    filter.operator === 'within'
                  "
                >
                  <div slot="toggle" class="query-dropdown-toggle">
                    <div class="query-dropdown-toggle-label label-border" data-filter-duration>
                      {{ filter.payload.duration }}
                    </div>
                  </div>
                </fts-dropdown-select>
                <!-- date details type (today, tomorrow, this month etc) -->
                <fts-dropdown-select
                  append-to-body
                  :options="dateDetailsTypes"
                  option-key="displayName"
                  prevent-overflow-alt-axis
                  prevent-overflow-tether-off
                  class="query-dropdown"
                  @selected="(val) => (mutableOffset = val.offset)"
                  v-if="filter.operator === 'within'"
                >
                  <div slot="toggle" class="query-dropdown-toggle">
                    <div class="query-dropdown-toggle-label label-border" data-filter-duration-offset>
                      {{ getDurationOffset }}
                    </div>
                  </div>
                </fts-dropdown-select>
              </template>
            </div>
          </div>
        </div>
        <!-- state -->
        <fts-dropdown-select
          append-to-body
          :options="states"
          prevent-overflow-alt-axis
          prevent-overflow-tether-off
          class="query-dropdown"
          @selected="setState"
          v-if="getInformationType(filter.fieldId) == 'state'"
        >
          <div slot="toggle" class="query-dropdown-toggle">
            <fts-state :state="filter.payload" :states="states" />
          </div>
          <div
            slot="option"
            slot-scope="{ option, select, defaultClass }"
            :class="defaultClass"
            @click="select(option)"
          >
            <fts-state :state="option" />
          </div>
        </fts-dropdown-select>
      </template>
      <!-- search action -->
      <div class="query-action">
        <font-awesome-icon
          class="remove-icon"
          :icon="['fas', 'times']"
          fixed-width
          @click="removeFilter()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import commons from "../commons/commons";
import queryLogic from "../commons/queryLogic";
import { authorizationStore } from "../store/authorizationStore";
import { clientStore } from '../store/clientStore';
import { store as canvasDesignStore } from "../store/canvasDesignStore";

import FTSDateTime from "./FTSDateTime";
import FTSDateTimeRange from "./FTSDateTimeRange";
import FTSDropdownSelect from "./FTSDropdownSelect";
import FTSFormula from "../design/FTSFormula.vue";
import FTSFormulaSwitch from "../design/FTSFormulaSwitch";
import FTSInteger from "./FTSInteger";
import FTSLabelGroup from './FTSLabelGroup';
import FTSNumberCurrency from "./FTSNumberCurrency";
import FTSState from "./FTSState";
import FTSUser from "./FTSUser";

import draggable from "vuedraggable";
import VueJsonPretty from "vue-json-pretty";

export default {
  name: "fts-query",
  props: {
    modules: Array,
    states: Array,
    informationSource: Array,
    variables: Array,
    filter: Object,
    mode: {
      type: String,
      validator: (value) => ["view", "formula"].includes(value),
    },
  },
  components: {
    draggable,
    "fts-date-time": FTSDateTime,
    "fts-date-time-range": FTSDateTimeRange,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-formula": FTSFormula,
    "fts-formula-switch": FTSFormulaSwitch,
    "fts-integer": FTSInteger,
    "fts-label-group": FTSLabelGroup,
    "fts-number-currency": FTSNumberCurrency,
    "fts-state": FTSState,
    "fts-user": FTSUser,
    VueJsonPretty,
  },
  data: () => ({
    fieldFormData: {},
    dragOptions: commons.dragOptions,
    selectionFilter: null,
  }),
  methods: {
    setNumber(field, event) {
      this.$set(this.filter, field, parseFloat(event.data));
    },
    setUserName(data) {
      this.$set(this.filter, "payload", data);
    },
    toggleContainerType() {
      const getFilterType = () => {
        try {
          const conditions = this.informationSource
            .filter(
              (x) =>
                x.type === "condition" &&
                queryLogic.querySelectionSuffix.some(
                  (y) => y.fieldName === x.fieldName
                )
            )
            .map((x) => x.fieldName);
          const findIndex = conditions.indexOf(this.filter.type);

          if (conditions.length) {
            return findIndex + 1 < conditions.length
              ? conditions[findIndex + 1]
              : conditions[0];
          } else {
            throw "undefined conditions";
          }
        } catch (err) {
          console.error(err);
          return "(undefined)";
        }
      };
      this.filter.type = getFilterType();
    },
    addFilter(childInformation) {
      if (
        Array.isArray(this.informationSource) &&
        this.informationSource.length
      ) {
        if (this.filter.items == null) {
          this.$set(this.filter, "items", []);
        }

        if (childInformation) {
          this.filter.items.push({
            id: commons.nanoID(),
            ...queryLogic.prepareQueryUnit(
              childInformation,
              childInformation[0].id
            ),
          });
        } else {
          this.filter.items.push({
            id: commons.nanoID(),
            ...queryLogic.prepareQueryUnit(
              this.informationSource,
              this.informationSource[0].id
            ),
          });
        }

        this.updateFilter();
      }
    },
    updateFilter() {
      this.$emit("update");
    },
    removeFilter(filter) {
      if (filter && Array.isArray(this.filter.items)) {
        const filterIndex =
          Array.isArray(this.filter.items) && this.filter.items.indexOf(filter);
        if (filterIndex > -1) {
          this.filter.items.splice(filterIndex, 1);
          this.updateFilter();
        }
      } else {
        this.$emit("remove", this);
      }
    },
    informationIcon(item) {
      switch (item.type) {
        case "state":
          return "fts-icon-state";
        case "collaboration":
          return "fts-icon-users";
        case "condition":
          if (item.fieldName === "or") return "fts-icon-or";
          else if (item.fieldName === "not") return "fts-icon-not-equal";
          else if (item.fieldName === "and") return "fts-icon-and";
        case "custom":
          return commons.informationIcon(0);
        case "formula":
          return commons.informationIcon(32);
        default:
          return commons.informationIcon(item.type);
      }
    },
    getDefaultSelection(item) {
      if (item.system) return true;

      return !!queryLogic.querySelectionSuffix.find(
        (x) => x.fieldName === item.fieldName
      );
    },
    getInformationDisplayName(item) {
      let res = null;
      try {
        const id = item.fieldId || item.id;
        if (["condition", "formula", "custom"].indexOf(item.type) !== -1) {
          res = this.selection.find((x) => x.fieldName === item.fieldName);
        } else {
          res = this.selection.find((x) => x.id === id);
        }
      } catch (err) {
        console.error("Query:DisplayName", err);
      }

      if (res && res.label) return res.label;
      else if (res && res.displayName) return res.displayName;
      else return "(undefined)";
    },
    getInformationType(fieldId) {
      return queryLogic.getInformationType(this.selection, fieldId);
    },
    getSearchTypes(filterType) {
      return queryLogic.getSearchTypes(filterType);
    },
    getSearchTypeDisplay(filter) {
      if (filter.type == "formula") {
        let operator = queryLogic
          .getSearchTypes("formula")
          .find((x) => x.fieldName == filter.operator);
        if (operator) return operator.displayName;
      }

      let type = this.getInformationType(filter.fieldId);
      if (type) {
        let operator = queryLogic
          .getSearchTypes(type)
          .find((x) => x.fieldName == filter.operator);
        if (operator) return operator.displayName;
      }

      return "(unknown operator)";
    },
    getTableInformationSource(filter) {
      const informationSource = this.informationSource.find((x) => x.id == filter.fieldId);
      if (informationSource && informationSource.fields) {
        return informationSource.fields.filter((x) => {
          const informationType = commons.informationTypes.find(y => y.id === x.type);
          return informationType && informationType.searchable;
        });
      } else {
        return [];
      }
    },
    getSelectOptionColor(item) {
      return commons.selectOptionBackground({
        optionList:
          this.getSelectOptions &&
          this.getSelectOptions.filter((x) => x.id !== null),
        text: item,
      });
    },
    setFieldName(data) {
      if (data && data.type === "condition") {
        this.$set(this.filter, "type", data.fieldName ? data.fieldName : "and");
        this.$set(this.filter, "items", []);
        this.$delete(this.filter, "fieldId");
        this.$delete(this.filter, "fieldName");
        this.$delete(this.filter, "system");
        this.$delete(this.filter, "operator");
        this.$delete(this.filter, "payload");
        this.$delete(this.filter, "name");
      } else if (data && data.type === "custom") {
        this.$set(this.filter, "type", "custom");
        this.$set(this.filter, "name", "");
      } else if (data && data.type === "formula") {
        this.$set(this.filter, "type", "formula");
        this.$set(this.filter, "name", "");
      } else {
        /* reset */
        if (this.filter.hasOwnProperty("payload"))
          this.$delete(this.filter, "payload");
        if (this.filter.hasOwnProperty("items"))
          this.$delete(this.filter, "items"); 
        /* set */
        Object.assign(this.filter, {
          ...queryLogic.prepareQueryUnit(this.selection, data.id),
          id: commons.nanoID(),
        });
        /* set default state */
        if (data.type === "state" && !this.filter.status)
          this.setInitialState();
      }
    },
    changeOperator(data) {
      if (data.fieldName !== this.filter.operator) {
        /* set */
        this.filter.operator = data.fieldName;
        /* reset */
        if (
          this.filter.operator == "within" ||
          this.filter.operator == "in" ||
          this.filter.operator == "past"
        ) {
          this.$set(this.filter, "payload", { duration: "day", offset: 0 });
        } else if (!(this.filter.fieldId === "state" && this.filter.system)) {
          this.$delete(this.filter, "payload");
        }

        if (this.filter.operator == "all" || this.filter.operator == "any") {
          this.$set(this.filter, "items", []);
        }
      }
    },
    setState(data) {
      const state = { ...data };
      this.$set(this.filter, "payload", {
        id: state.id,
        name: state.name,
      });
    },
    setInitialState() {
      const state = { ...this.states[0] };
      this.$set(this.filter, "payload", {
        id: state.id,
        name: state.name,
      });
    },
    setDateDurationOffset(data) {
      this.filter.payload.duration = data.fieldName;
      if (
        !Boolean(
          this.formulaSwitchEnabled &&
            this.mutableOffset &&
            this.mutableOffset.hasOwnProperty("formula")
        )
      ) {
        this.filter.payload.offset = 0;
      }
    },
    onTextInput() {
      if (
        this.filter &&
        this.filter.operator === "is" &&
        !this.filter.payload
      ) {
        this.$delete(this.filter, "payload");
      }
    },
  },
  computed: {
    getFilterInfo() {
      if (this.filter) {
        const res = this.selection.find((x) => x.id == this.filter.fieldId);
        if (res) {
          return {
            "type": res.type,
            "displayName": res.label || res.displayName,
            "system": res.system,
            "connectionId": res.connectionId
          }
        }
      }
    },
    searchTextType() {
      const type = this.getInformationType(this.filter.fieldId);
      switch (type) {
        case "Text":
        case "Select":
        case "Tag":
        case "Locus":
        case "Module":
        case "Modules":
        case "Email":
        case "Phone Number":
        case "Link":
        case "Location":
          return "Text";
        case "Multiline Text":
          return "Textarea";
        case "YesNo":
          return "YesNo";
        case "Integer":
        case "Number":
        case "Money":
        case "Currency":
          return "Number";
        case "User":
        case "Users":
        case "Profile (Module)":
        case "Username":
          return "User";
        case "Date":
        case "Date Time":
          return "Date";
      }
    },
    dateDetailsTypes() {
      return queryLogic.getDatePredefinedselection(
        this.filter.payload.duration
      );
    },
    getDateTypes() {
      return [
        { displayName: "day", fieldName: "day" },
        { displayName: "week", fieldName: "week" },
        { displayName: "month", fieldName: "month" },
        { displayName: "year", fieldName: "year" },
      ];
    },
    selection() {
      return this.informationSource;
    },
    getSearchableSelection() {
      if (Array.isArray(this.informationSource)) {
        return queryLogic
          .getSearchableColumns(
            this.informationSource, 
            {
              workspaceBeta: this.$route.name == "builder" || this.$route.name == "studio" ? canvasDesignStore.getters.workspaceBeta : clientStore.getters.workspaceBeta
            }
          )
          .map(x => {
            let column = {...x};
            const columnSearchableRelease = queryLogic.getColumnSearchableRelease(column);

            if (columnSearchableRelease == 'dev') {
              column.isDev = true;
            } else if (columnSearchableRelease == 'alpha') {
              column.isAlpha = true;
            } else if (columnSearchableRelease == 'beta') {
              column.isBeta = true;
            } 

            return column;
          })
        ;
      }
      return [];
    },
    getSelection() {
      return this.getSearchableSelection.filter(
        (x) =>
          !this.selectionFilter ||
          x.displayName
            .toLowerCase()
            .indexOf(this.selectionFilter.toLowerCase()) > -1
      );
    },
    getDurationOffset() {
      if (
        this.filter.payload &&
        this.filter.payload.duration &&
        this.filter.payload.offset != null
      ) {
        let durations = this.dateDetailsTypes;
        let result = durations.find(
          (x) => x.offset == this.filter.payload.offset
        );
        if (result) {
          return result.displayName;
        }
      }

      return "-";
    },
    getSelectOptions() {
      const information = this.informationSource.find(
        (x) => x.id === this.filter.fieldId
      );
      if (
        information &&
        (information.type == 27 || information.type == 28) &&
        Array.isArray(information.optionList) &&
        information.optionList.length
      )
        return [{ id: null }].concat(information.optionList);
    },
    formulaSwitchEnabled() {
      return this.mode === "formula";
    },
    mutableMin: {
      get() {
        return this.filter.payload && this.filter.payload.min;
      },
      set(val) {
        if (!this.filter.payload) {
          this.$set(this.filter, "payload", {});
        }

        if (
          this.formulaSwitchEnabled &&
          Boolean(val && val.hasOwnProperty("formula"))
        ) {
          this.$set(this.filter.payload, "min", val);
        } else if (commons.isNumber(val)) {
          this.$set(this.filter.payload, "min", parseFloat(val));
        } else {
          this.$delete(this.filter.payload, "min");
        }
      },
    },
    mutableMax: {
      get() {
        return this.filter.payload && this.filter.payload.max;
      },
      set(val) {
        if (!this.filter.payload) {
          this.$set(this.filter, "payload", {});
        }

        if (
          this.formulaSwitchEnabled &&
          Boolean(val && val.hasOwnProperty("formula"))
        ) {
          this.$set(this.filter.payload, "max", val);
        } else if (commons.isNumber(val)) {
          this.$set(this.filter.payload, "max", parseFloat(val));
        } else {
          this.$delete(this.filter.payload, "max");
        }
      },
    },
    mutableOffset: {
      get() {
        return this.filter.payload && this.filter.payload.offset;
      },
      set(val) {
        if (!this.filter.payload) {
          this.$set(this.filter, "payload", {});
        }

        if (
          this.formulaSwitchEnabled &&
          Boolean(val && val.hasOwnProperty("formula"))
        ) {
          this.$set(this.filter.payload, "offset", val);
        } else if (commons.isNumber(val)) {
          this.$set(this.filter.payload, "offset", parseFloat(val));
        } else {
          this.$delete(this.filter.payload, "offset");
        }
      },
    },
    mutableEqual: {
      get() {
        return this.filter.payload;
      },
      set(val) {
        if (
          this.formulaSwitchEnabled &&
          Boolean(val && val.hasOwnProperty("formula"))
        ) {
          this.$set(this.filter, "payload", val);
        } else if (commons.isNumber(val)) {
          this.$set(this.filter, "payload", parseFloat(val));
        } else {
          this.$delete(this.filter, "payload");
        }
      },
    },
    mutableDateBeforeAfter: {
      get() {
        return this.filter.payload;
      },
      set(val) {
        this.$set(this.filter, "payload", !!val ? val : null);
      }
    },
    userFieldItem() {
      let information = _.cloneDeep(this.selection.find((x) => x.id === this.filter.fieldId));

      if (information.type == 21)
        information.type = 20;

      const valuesToKeep = ["id", "type", "displayName", "fieldName", "connection", "connectionId", "connectionField", "connectionFieldId", "label"];
      for (const key in information) {
        if (!valuesToKeep.includes(key)) {
          delete information[key];
        }
      }

      return information;
    },
    users() {
      return canvasDesignStore.state.users
        .filter(user => authorizationStore.getters.isAdminUser || !user.disable)
        .map(user => ({
          username: user.userName || user.username,
          displayName: user.displayName,
          disable: user.disable
        }));
    },
    isTextInput() {
      return (
        ((this.searchTextType === "Text" ||
          this.searchTextType === "Textarea") &&
          this.filter.operator !== "isNone") ||
        ((this.searchTextType === "User" ||
          this.searchTextType === "Profile (Module)") &&
          (this.filter.operator == "contains" || this.filter.operator == "is"))
      );
    },
  },
  mounted() {
    /* initial set state */
    if (
      this.filter.system &&
      this.filter.fieldId === "state" &&
      !this.filter.payload
    ) {
      this.setInitialState();
    }
    /* set username */
    if (
      this.searchTextType === "User" &&
      this.filter &&
      this.filter.operator == "is" &&
      this.filter.fieldName &&
      this.filter.payload
    ) {
      this.$set(this.fieldFormData, this.filter.fieldName, this.filter.payload);
      this.$set(
        this.fieldFormData,
        `${this.filter.fieldName}Username`,
        this.filter.payload
      );
    }
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-query {
  $input-number-width: 8rem;
  position: relative;
  color: var(--fts-text);
  .fts-query-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0.175rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    font-size: var(--inistate-label-text-14);
    line-height: var(--inistate-paragraph-text-14--line-height);
    &:hover {
      border-color: var(--fts-border);
      & > .query-action {
        visibility: visible;
      }
      & > .query-designer-handle {
        visibility: visible;
      }
    }
    > .query-designer-handle {
      visibility: hidden;
    }
    /* nested query */
    .nested-query {
      margin: 0.375rem;
      padding: 0.375rem;
      &.or-container {
        flex-direction: column;
        &:hover {
          border-color: var(--fts-secondary);
        }
      }
      .nested-query-wrapper {
        display: flex;
        align-items: flex-start;
        > .query-badge {
          margin: 0.875rem 0.375rem 0.375rem 0;
        }
      }
    }
    /* query dropdown */
    .query-dropdown {
      @include user-select-none;
      min-width: 0;
      // Query Dropdown Toggle
      .query-dropdown-toggle {
        margin: 0.175rem 0;
        text-align: center;
        .query-dropdown-toggle-label {
          @include flex-center-middle;
          flex-wrap: wrap;
          padding: 0.175rem;
          color: var(--fts-text);
          &:not(.label-border) {
            border: 1px solid transparent;
          }
        }
      }
    }
    /* query search form */
    .query-search-form {
      min-width: 0;
      .query-search-form-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .query-search-form-group {
          margin-left: 0.175rem;
          flex: 1;
          &.custom-script {
            min-width: 450px;
          }
          &.form-group-date-time-range {
            .reportrange-text {
              min-width: 175px;
              > div {
                white-space: nowrap;
              }
            }
          }
        }
      }
      .query-search-form-text {
        font-size: 0.875rem;
        cursor: default;
      }
    }
    /* query seach number */
    .query-search-number {
      position: relative;
      &.equal {
        .query-search-number__input {
          width: calc(#{$input-number-width + 2.25rem});
          padding-left: 2.25rem;
        }
      }
      .query-search-number__label {
        @include absolute-center-y;
        @include pointer-events-none;
        left: 6px;
        color: var(--fts-primary);
        font-size: 0.575rem;
        font-weight: bold;
        letter-spacing: 0.09em;
      }
      .query-search-number__input {
        width: calc(#{$input-number-width + 1.75rem});
        padding-left: 1.75rem;
      }
    }
    /* query search input */
    .query-number-input {
      width: $input-number-width;
    }
    /* query action */
    .query-action {
      @include flex-center-middle;
      height: $form-control-height;
      margin-left: 0.175rem;
      visibility: hidden;
      font-size: 0.75rem;
      color: var(--fts-default);
      svg {
        margin: 0.175rem;
        &.remove-icon {
          color: var(--fts-danger);
          cursor: pointer;
        }
      }
    }
  }
  /* icon */
  .yes-icon {
    margin-right: 0.575rem;
    color: var(--fts-success);
  }
  .no-icon {
    margin-right: 0.575rem;
    color: var(--fts-danger);
  }
}
/* query badge */
.query-badge {
  padding: 0.135rem 0.575rem;
  border-radius: 10rem;
  background-color: var(--fts-primary);
  color: #fff;
  font-size: 0.675rem;
  line-height: 1.5;
  letter-spacing: 0.089em;
  cursor: pointer;
  &.or-query-badge {
    background-color: var(--fts-secondary);
  }
  &.not-query-badge {
    background: var(--fts-danger);
  }
  &:hover {
    box-shadow: $btn-box-shadow-hover;
  }
}
/* query select toggle */
.query-select-toggle {
  max-width: pxToRem(250px) - 0.75rem - 0.75rem;
}
/* query select option */
.query-select-option {
  @include text-overflow-ellipsis;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  border-radius: 0.25rem;
  font-size: var(--inistate-label-text-14);
  line-height: var(--inistate-paragraph-text-14--line-height);
  background-color: #d9d9d9;
  color: #000;
}
/* query dropdown menu */
.query-content.query-dropdown-menu {
  padding: 0 0 0.375rem;
  /* filter */
  .query-filter {
    @include theme() {
      @include backdrop-background(
        $color: theme-get("fts-popover-alt-background"),
        $blur: 2px
      );
    }
    position: sticky;
    top: 0;
    padding: 0.75rem 0.375rem 0.375rem;
  }
}
/* query select menu */
.query-content.query-select-menu {
  .query-select-option {
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
  }
}
</style>